import Contacts from "../../components/Songs/Contacts"

const ContactsScreen = () => {
  return <Contacts />;
}
export default ContactsScreen;